import React from "react";
import DBService from "../../../Services/dexieForm";
import { Link } from "react-router-dom";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from '@material-ui/core/Button';
//import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography"

const styles = (theme) => ({
  table: {
    minWidth: 650,
  },
  cell:{
    fontSize:12
  },
  alignItems: {
    display: "flex",
    //width: 600,
    //"justify-content": "space-between",
    "padding-bottom": 20,
    flexDirection:"row",
    //flexWrap: "nowrap"
    "justifyContent": "space-between"
  },
  formDiv:{
    margin: theme.spacing(4, 4),
    display: "flex",
    flexDirection: "column", 
  }
});

class RegisterList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { builderFormsList: [] }; //default

    this.handleClick = this.handleClick.bind(this);
    this.handleClickNew = this.handleClickNew.bind(this);
  }

  async componentDidMount() {
    DBService.initialize();
    let list = await DBService.getUniverseList();
    this.setState({ builderFormsList: list });
  }

  handleClick(item) {
    console.log("clicked Item - ", item);
    this.props.history.push(`/register/${item.id}`);
  }
  handleClickNew(item) {
   
    this.props.history.push(`/register/-100`);
  }

  render() {
    const list = this.state.builderFormsList;
    const {classes} = this.props;
    return (
      <div className="pageHeaderPanel">
      <div className="page-header1">
              <h5>Register List</h5>
            <div className="btn-toolbar justify-content-end ">
              {/* <Link to="/framework/-100">Add New</Link> */}          
              <div onClick={this.handleClickNew} className="btn  btn-icon btn-outline-primary btnAction" title="Add New">
                <i className="fa fa-plus-square" aria-hidden="true"></i>
              </div> &nbsp;
            </div>
          </div>
        
        {list.length > 0 && (
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right"><b>Actions</b></TableCell>                 
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell component="th" scope="row">
                    
                      <Button onClick={() => this.handleClick(item)}>{item.name}</Button>
                       
                    </TableCell>
                    <TableCell className={classes.cell} align="right">
                    <Link to={`registerInstance/${item.id}`}>List</Link>
                    </TableCell>
                    <TableCell className={classes.cell} align="right">
                    
                    <Link to={`register/${item.id}`}>Edit</Link>
                    </TableCell>
                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {list.length == 0 &&
        <div className="tablePanel-body noPanelBody">
           <h2>No Registers</h2>
        </div>
        }
      </div>
    );
  }
}

export default withStyles(styles)(RegisterList);
